import React from 'react';
import styled from 'styled-components/macro';
import List from './List';
import { trackFont } from '../styles/Font';

const ContentContainer = styled.section`
  margin: 30px;
  max-width: 1096px;
  width: 100%;
`;

const ContentText = styled.span`
  ${trackFont}
`;

const Content = () => (
  <ContentContainer>
    <ContentText>
      This page lists GTFS feeds produced by GMV in North America. It is intended to be discoverable for
      use by real-time passenger information and trip-planning consumers.
      <br />
      <br />
      This directory is also available as a JSON response at:{' '}
      <a href={`${window.location}api`} title="JSON format">
        {`${window.location}api`}
      </a>
      <br />
      <br />
      For more information about GMV and how we can provide real-time passenger
      information and dispatch tools for your agency, visit{' '}
      <a
        href="http://www.gmvsync.com"
        title="GVM Sync"
        target="_blank"
        rel="noreferrer noopener"
      >
        www.gmvsync.com
      </a>
    </ContentText>
    <List />
  </ContentContainer>
);

export default Content;
